module.exports = __webpack_public_path__ + "img/login-bg04.9c6eebde.png";